module.exports = __webpack_public_path__ + "static/media/9.28a9fea1.JPG";